import React, { useMemo, useState } from "react";

import { Button } from "../components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "../components/ui/card";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { djangoApi } from "../services/djangoApi";

function joinUrl(base, path) {
  // Remove trailing /api or /api/ from base to avoid duplication
  const normalizedBase = (base || "").replace(/\/+$/, "").replace(/\/api\/?$/, "");
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${normalizedBase}${normalizedPath}`;
}

export default function ApiKeyPage({ onValidated }) {
  const apiBaseDefault =
    process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_API_URL || "";
  const validateEndpoint = useMemo(() => {
    return apiBaseDefault
      ? joinUrl(apiBaseDefault, "/api/pdf2json/validate-key")
      : "/api/pdf2json/validate-key";
  }, [apiBaseDefault]);

  const [apiKeyInput, setApiKeyInput] = useState("");
  const [status, setStatus] = useState("idle");
  const [error, setError] = useState("");

  async function onSubmit(event) {
    event.preventDefault();
    const trimmed = apiKeyInput.trim();
    if (!trimmed) {
      setError("Please enter a valid API key.");
      return;
    }

    setError("");
    setStatus("submitting");
    try {
      const data = await djangoApi.validateApiKey(trimmed);
      setStatus("idle");
      setApiKeyInput("");
      onValidated({ apiKey: trimmed, clientInfo: data });
    } catch (e) {
      setStatus("error");
      if (e?.code === "ERR_NETWORK" || e?.message?.includes("Network Error")) {
        setError(
          `Connection error: Cannot reach backend at ${validateEndpoint}. Is the backend running?`,
        );
      } else {
        setError(e instanceof Error ? e.message : "API key validation failed");
      }
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="w-full max-w-md p-4">
        <div className="w-full">
          <Card>
            <CardHeader>
              <CardTitle>API Key Required</CardTitle>
              <CardDescription>
                Enter your API key to access the PDF → JSON workspace.
              </CardDescription>
            </CardHeader>
            <CardContent>
              <form onSubmit={onSubmit} className="space-y-4">
                <div className="space-y-2">
                  <Label htmlFor="apiKeyGate">API Key</Label>
                  <Input
                    id="apiKeyGate"
                    value={apiKeyInput}
                    onChange={(e) => setApiKeyInput(e.target.value)}
                    placeholder="ULID key"
                    autoFocus
                  />
                </div>
                {error ? (
                  <div className="rounded-md border border-destructive/30 bg-destructive/10 p-3 text-sm text-destructive">
                    {error}
                  </div>
                ) : null}
                <Button type="submit" disabled={status === "submitting"}>
                  {status === "submitting" ? "Validating..." : "Continue"}
                </Button>
              </form>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
}
